import React from 'react';
import AccessLogApp from '../../../Functionality/EmployeeDetailsFlows/AcessLog/AccessLogApp';
import CustomTable from '../../../../../../components/table/CustomTable';
import {ACCESS_LOG_GET_DATA} from '../../../../../Dashboard/Contractors/Model/Models';

/**
 * @Author: Cecilia López Martínez
 * @JobTitle: Full Stack Developer - IBL
 * @Email: clopez@ibl.mx
 */
const AccessLog = (
    {
        id,
        option,
        accessLogMode
    }
) => {

    const {
        t,
        tableId, searchId,
        thead, tbody, pagination
    } = AccessLogApp({   id, option, accessLogMode });

    return (
        <>
            <CustomTable
                tableId={tableId}
                searchId={searchId}
                checkbox={false}
                checkboxTitle={"de_/_select_all"}
                isAllChecked={false}
                onChangeCheckbox={() => { }}
                thead={thead}
                tbody={tbody}
                columnActions={false}
                getActionsButtons={<></>}
                selectedList={[]}
                childrenNotInformation={
                    tbody?.data?.length === 0 ?
                        <>
                            <div className={"warning-text"}>
                                <p>{t(ACCESS_LOG_GET_DATA[accessLogMode].txtNotInformation)}</p>
                            </div>
                        </>
                        : undefined
                }
            />
            {pagination()}
        </>
    );
}

export default AccessLog
